export enum GoogleAnalyticsEventType {
  DmWelcome = 'DM_welcome',
  DmMatchResult = 'DM_Match_Result',
  DmPersonalInfo = 'DM_PersonalInfo',
  DmBranchOfferWithSummit = 'DM_Branch_offer',
  ApplyProcessPersonalInfo = 'apply-process_PersonalInfo',
  ApplyProcessContactInfo = 'apply-process_ContactInfo',
  ApplyProcessEmailVerify = 'apply-process_EmailVerify',
  ApplyProcessPhoneVerify = 'apply-process_PhoneVerify',
  ApplyProcessIncome = 'apply-process_Income',
  ApplyProcessConsent = 'apply-process_Consent',
  ApplyProcessBranchOffer = 'apply-process_BranchOffer',
  ApplyProcessOnlineOffer = 'apply-process_OnlineOffer',
  ApplyProcessOnlineOfferRefi = 'apply-process_OnlineOfferRefi',
  ApplyProcessPPCJourneyOffer = 'apply-process_PPCJourneyOffer',
  ApplyProcessMoreInformation = 'apply-process_MoreInformation',
  ApplyProcessBankingCollection = 'apply-process_BankingCollection',
  ApplyProcessBankAcctSelect = 'apply-process_BankAcctSelect',
  ApplyProcessLoanDocs = 'apply-process_LoanDocs',
  ApplyProcessBranchOfferGeneric = 'apply-process_BranchOfferGeneric',
  ApplyProcessCentralBranch = 'apply-process_CentralBranch',
  ApplyProcessPhysicalBranch = 'apply-process_PhysicalBranch',
  ApplyProcessDecline = 'apply-process_Decline',
  ApplyProcessFundingNewLoan = 'apply-process_FundingNewLoan',
  ApplyProcessFundingRefi = 'apply-process_FundingRefi',
  ApplyProcessAutoPayEnroll = 'apply-process_AutoPayEnroll',
  ApplyProcessAutoPaySetup = 'apply-process_AutoPaySetup',
  PrequalCompleted = 'prequalCompleted',
  AutopayDecision = 'autopayDecision',
  OnlineOrigination = 'onlineOrigination',
  CreatedApp = 'createdApp',
  FundedStatus = 'fundedStatus',
}

export enum GoogleAnalyticsEvent {
  PageView = 'page_view',
  AutopayDecision = 'autopayDecision',
  PrequalCompleted = 'prequalCompleted',
  OnlineOrigination = 'onlineOrigination',
  CreatedApp = 'createdApp',
  FundedStatus = 'fundedStatus',  
  DmOnlineOffer = 'dmOnlineOffer',
  DmNoMatch = 'dmNoMatch',
  DmBranchOffer = 'dmBranchOffer',
}

export enum GoogleAnalyticsScreen {
  DmWelcome = 'DM_welcome',
  DmPersonalInfo = 'DM_PersonalInfo',
  DmBranchOfferWithSummit = 'DM_Branch_offer',
  ApplyProcessPersonalInfo = 'apply-process_PersonalInfo',
  ApplyProcessContactInfo = 'apply-process_ContactInfo',
  ApplyProcessEmailVerify = 'apply-process_EmailVerify',
  ApplyProcessPhoneVerify = 'apply-process_PhoneVerify',
  ApplyProcessIncome = 'apply-process_Income',
  ApplyProcessConsent = 'apply-process_Consent',
  ApplyProcessBranchOffer = 'apply-process_BranchOffer',
  ApplyProcessOnlineOffer = 'apply-process_OnlineOffer',
  ApplyProcessOnlineOfferRefi = 'apply-process_OnlineOfferRefi',
  ApplyProcessPPCJourneyOffer = 'apply-process_PPCJourneyOffer',
  ApplyProcessMoreInformation = 'apply-process_MoreInformation',
  ApplyProcessBankingCollection = 'apply-process_BankingCollection',
  ApplyProcessBankAcctSelect = 'apply-process_BankAcctSelect',
  ApplyProcessLoanDocs = 'apply-process_LoanDocs',
  ApplyProcessBranchOfferGeneric = 'apply-process_BranchOfferGeneric',
  ApplyProcessCentralBranch = 'apply-process_CentralBranch',
  ApplyProcessPhysicalBranch = 'apply-process_PhysicalBranch',
  ApplyProcessDecline = 'apply-process_Decline',
  ApplyProcessFundingNewLoan = 'apply-process_FundingNewLoan',
  ApplyProcessFundingRefi = 'apply-process_FundingRefi',
  ApplyProcessAutoPayEnroll = 'apply-process_AutoPayEnroll',
  ApplyProcessAutoPaySetup = 'apply-process_AutoPaySetup',
  AutopayDecision = 'autopayDecision',
}
